var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.18,
    height: 14.644,
    viewBox: "0 0 15.18 14.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M7.9.484l-1.765,3.6-3.949.579A.872.872,0,0,0,1.7,6.15l2.857,2.8L3.885,12.91a.866.866,0,0,0,1.254.917l3.533-1.869L12.2,13.827a.866.866,0,0,0,1.254-.917l-.676-3.958,2.857-2.8a.872.872,0,0,0-.478-1.485l-3.949-.579L9.447.484A.863.863,0,0,0,7.9.484Z",
    transform: "translate(-1.081 0.351)",
    fill: "#fff",
    stroke: "#d0d0d0",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFav);
export default __webpack_public_path__ + "static/media/iconFav.a12d3d29f41819a01a3246606963c92d.svg";
export { ForwardRef as ReactComponent };